export default "__VITE_ASSET__BIrZ05Fn__"